module.exports = __webpack_public_path__ + "img/1989_S.2043666d.png";